<fui-heading [text]="'AI Assistant Usage'" [level]="5"></fui-heading>
<span class="text-muted">Unique users and message volume per month, across all AI Assistant clients.</span>

<div class="row m-t-20">
  <div class="col-12 m-b-15 d-flex align-items-center justify-content-between flex-wrap usage-toolbar">
    <button class="small-btn" (click)="showCustomRange = !showCustomRange">
      <fa-icon [icon]="showCustomRange ? 'chevron-down' : 'chevron-right'"></fa-icon>
      Custom range
    </button>
    @if (!loading && rows.length) {
      <button class="brand-btn-reverse sm" (click)="downloadCsv()">
        <fa-icon icon="download"></fa-icon>
        Download CSV
      </button>
    }
  </div>

  @if (showCustomRange) {
    <div class="col-12 m-b-20">
      <div class="usage-range">
        <div class="usage-range-field">
          <label for="usage-start-month">Start month</label>
          <input id="usage-start-month" type="month" class="form-control" [(ngModel)]="startMonth" name="startMonth" />
        </div>
        <div class="usage-range-field">
          <label for="usage-end-month">End month</label>
          <input id="usage-end-month" type="month" class="form-control" [(ngModel)]="endMonth" name="endMonth" />
        </div>
        <div class="usage-range-actions">
          <button class="brand-btn-reverse sm" (click)="load()">Apply</button>
          <button class="small-btn m-l-5" (click)="resetRange()">Last 12 months</button>
        </div>
      </div>
      @if (rangeError) {
        <p class="text-danger m-t-10">{{ rangeError }}</p>
      }
      <span class="text-muted">Leave a month blank to let the report fill it in. Months are UTC.</span>
    </div>
  }
</div>

@if (loading) {
  <myp-inline-loader [loading]="loading" height="240px" spinnerName="ai-assistant-usage-loader"></myp-inline-loader>
}

@if (!loading) {
  @if (loadError) {
    <p class="text-danger">Could not load the usage report. Please try again.</p>
  } @else if (!rows.length) {
    <p class="text-muted">No usage recorded in this range.</p>
  } @else {
    <div class="usage-chart-wrap m-b-25">
      <canvas #usageChart></canvas>
    </div>

    <div class="usage-table-scroll">
      <table class="usage-table">
        <thead>
          <tr>
            <th scope="col" class="month-col">Month</th>
            <th scope="col">Unique users</th>
            <th scope="col">Messages</th>
            <th scope="col">User days</th>
            <th scope="col">Avg / user</th>
            <th scope="col">Median / user</th>
            <th scope="col">New</th>
            <th scope="col">Returning</th>
            <th scope="col">Returning %</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.month) {
            <tr>
              <th scope="row" class="month-col">
                {{ row.label }}
                @if (row.beforeFullHistory) {
                  <span class="horizon-flag" title="Usage history starts partway through this month, so returning users are undercounted.">*</span>
                }
              </th>
              <td>{{ row.unique_users | number }}</td>
              <td>{{ row.messages | number }}</td>
              <td>{{ row.user_days | number }}</td>
              <td>{{ row.avg_messages_per_user }}</td>
              <td>{{ row.median_messages_per_user }}</td>
              <td>{{ row.new_users | number }}</td>
              <td>{{ row.returning_users | number }}</td>
              <td>{{ row.returningShare }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="usage-notes m-t-15">
      <p class="text-muted">
        <strong>Messages</strong>
        counts completed exchanges — one prompt plus its reply — not individual chat bubbles. A user is counted once per month no matter how many days they were active.
      </p>
      @if (historyStarts) {
        <p class="text-muted">
          Usage history begins {{ historyStarts }}. Months marked
          <span class="horizon-flag">*</span>
          start at or before that date, so their returning-user counts are understated.
        </p>
      }
      @if (generatedAt) {
        <p class="text-muted">Figures are cached for up to an hour. Last computed {{ generatedAt | date: "medium" }}.</p>
      }
    </div>
  }
}
